import React, { useState } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import FPS_Offline_Trans_Details from './FPS_Offline_Trans_Details';
import GetDistricts from '../../Dropdowns/getDistricts'
import GetFpsId from '../../Dropdowns/getFpsId'

const FPS_Offline_Trans_Abstract = ({ heading }) => {

    const [selectedDist, setSelectedDist] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [loadingFpsId, setLoadingFpsId] = useState(false);
    const [renderContent, setRenderContent] = useState(null);
  
    const handleDistrictChange = (dist_code) => {
      setSelectedDist(dist_code);
      
     };
  
    const handleSubmit = () => {
      const month = document.getElementById('month').value;
      const year = document.getElementById('year').value;
      const dist_code = document.getElementById('dist_code').value;
        const fps_id = document.getElementById('fps_id').value;

        if (!month || month == 0 || month == null || month == '') {
            alert('Please select Month');
        } else if (!year || year == 0 || year == null || year == '') {
            alert('Please select Year');
        } else if (!dist_code || dist_code == 0 || dist_code == null || dist_code == '') {
            alert('Please select District');
        } 
        else {
          setRenderContent(null);
          setTimeout(() => {
      setRenderContent(
        <FPS_Offline_Trans_Details month={month} year={year} fps_id={fps_id} districtName={selectedDist} heading={heading} />
      );
    }, 0);
  }
    };
  
    return (
      <div className="wrapper row3">
        <div id="container">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <table width="30%">
              <thead>
                <tr className="tableheader">
                  <th colSpan={8}>{heading}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Month</td>
                  <td><GetMonths onLoadingChange={setLoading} /></td>
                  <td>Year</td>
                  <td><GetYears onLoadingChange={setLoading} /></td>
                  <td>District</td>
                  <td>
                    <GetDistricts
                      onLoadingChange={setLoadingDistricts}
                      onChange={handleDistrictChange} />
                  </td>
                  <td>FPS</td>
                  <td>
                    <GetFpsId
                      dist_code={selectedDist}
                      onLoadingChange={setLoadingFpsId}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan={8} align="center">
                    <button onClick={handleSubmit} className="button button2" disabled={loading}>
                      Submit
                    </button>
                    <button className="button button2">
                      Back
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br></br>
          <div id="details1">{renderContent}</div>
        </div>
      </div>
          

    );
  };
  


export default FPS_Offline_Trans_Abstract;
